import * as dotProp from 'dot-prop-immutable';
import { Action } from 'typescript-fsa';

import { createReducer } from '../../frontendUtils';
import { hideLoader, LoadersNames, showLoader } from './ui.actions';

export type UIState = {
  readonly loaders: { [key in LoadersNames]?: boolean | [] };
};

export const initialState: UIState = {
  loaders: {
    [LoadersNames.fetchingData]: false,
  },
};

const uiReducer = createReducer(initialState, {
  [showLoader.type]: (state: UIState, action: Action<LoadersNames>) => {
    return dotProp.set(state, `loaders.${action.payload}`, true);
  },
  [hideLoader.type]: (state: UIState, action: Action<LoadersNames>) => {
    return dotProp.set(state, `loaders.${action.payload}`, false);
  },
});

export default uiReducer;
